import { i18n } from 'i18n';

export const CveType = {
  MACOS: 'macOS',
  APPLICATION: 'Application',
  BOTH: 'Both',
};

export const classifyCve = (software) => {
  const containsMacOS = software.filter((item) =>
    item.toLowerCase().includes('macos'),
  );
  const doesNotContainMacOS = software.filter(
    (item) => !item.toLowerCase().includes('macos'),
  );

  const containsSafari = software.some((item) =>
    item.toLowerCase().includes('safari'),
  );

  let classification;
  if (containsMacOS.length === software.length) {
    classification = CveType.MACOS;
  } else if (doesNotContainMacOS.length === software.length) {
    classification = CveType.APPLICATION;
  } else {
    classification = CveType.BOTH;
  }

  return {
    classification,
    containsSafari,
  };
};

export const getRemediationRecommendations = (software) => {
  if (!software || software.length === 0) {
    return i18n.t('Install the latest software provided by the developer');
  }

  const { classification, containsSafari } = classifyCve(software);
  const recommendations = [];

  if (classification === CveType.MACOS) {
    recommendations.push(
      i18n.t('Update to the latest macOS version when available.'),
    );
    return recommendations;
  }

  if (
    classification === CveType.APPLICATION ||
    classification === CveType.BOTH
  ) {
    recommendations.push(
      i18n.t('Install the latest software provided by the developer'),
    );
  }

  if (containsSafari) {
    recommendations.push(
      i18n.t('Safari cannot be uninstalled; ensure it is kept updated instead'),
      i18n.t('block other apps using the Application Blocking Library Item'),
      i18n.t(
        'or uninstall the application using a custom script if necessary.',
      ),
    );
  }

  if (!containsSafari) {
    recommendations.push(
      i18n.t(
        'block the application using the Application Blocking Library Item',
      ),
      i18n.t('uninstall the application using a custom script if necessary.'),
    );
  }

  return recommendations;
};
